import React from 'react';

export interface Sign0IconProps {}

export const Sign0Icon: React.FC<Sign0IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9741 3L17.8278 9.82965C17.9441 9.96545 17.9791 10.1531 17.9195 10.3217C17.834 10.5635 17.5816 10.6984 17.3375 10.6427L17.2814 10.6264L13.5 9.289V21H10.5V9.2705L6.66668 10.6264C6.51913 10.6786 6.35703 10.6583 6.22784 10.5745L6.17462 10.5347C5.98108 10.3688 5.9455 10.0871 6.08251 9.87981L6.12037 9.82965L11.9741 3Z"
        fill="#192033"
      />
    </svg>
  );
};
